const toysCategoryIds = {
  45269: true, // Toys
  5991: true, // Kids, Baby & Toys
  260274: true, // SHOP TOYS "R" US
};

const toysCategoryLabels = {
  toys: true,
  'kids, baby & toys': true,
  'shop toys "r" us': true,
};

export default function isToysCategory({ id, text, ignoreIdMatch, exactTextMatch }) {
  const lowerCaseText = text.toLowerCase();
  const textMatch = exactTextMatch ? toysCategoryLabels[lowerCaseText] === true : lowerCaseText.includes('toys');

  if (ignoreIdMatch) {
    return textMatch;
  }

  return toysCategoryIds[id] === true && textMatch;
}
